import type { ReactNode } from 'react'
import Footer from '@/components/Footer'
import SiteFaq, { type SiteFaqItem } from '@/components/marketing/SiteFaq'

export default function FaqFooter({
  title,
  faqs,
  ctaHref,
  ctaLabel,
}: {
  title: ReactNode
  faqs: readonly SiteFaqItem[]
  ctaHref?: string
  ctaLabel?: string
}) {
  return (
    <section className="relative isolate overflow-hidden bg-[#071631]">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-screen" aria-hidden>
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('/images/homepage/quote-bg.jpeg')" }}
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'rgb(0 57 122 / 85%)' }} />
      </div>
      <SiteFaq tone="dark" title={title} faqs={faqs} ctaHref={ctaHref} ctaLabel={ctaLabel} />
      <Footer variant="onDark" className="!bg-transparent" />
    </section>
  )
}
